export default __webpack_public_path__ + "img/ac537a2bc5ffc63e9b0a397d21a5bed2.svg";